import { AuthResponse, LoginDto, RegisterDto, User } from '../../types';
import api from './client';

// Auth Service
export const authService = {
  login: async (loginDto: LoginDto): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', loginDto);
    return response.data;
  },
  register: async (registerDto: RegisterDto): Promise<User> => {
    const response = await api.post<User>('/auth/register', registerDto);
    return response.data;
  },
  /** The signed-in user's profile — the JWT carries no display name. */
  getProfile: async (): Promise<User> => {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },
  /**
   * Always succeeds, whether or not the address has an account — the server
   * answers the same way either way so this cannot be used to find out who is
   * registered. Do not report "we couldn't find that email" from the result.
   */
  forgotPassword: async (email: string): Promise<void> => {
    await api.post('/auth/forgot-password', { email });
  },
  resetPassword: async (token: string, password: string): Promise<void> => {
    await api.post('/auth/reset-password', { token, password });
  },
  changePassword: async (
    currentPassword: string,
    newPassword: string,
  ): Promise<void> => {
    await api.post('/auth/change-password', { currentPassword, newPassword });
  },
};
